!<template>
  <v-card>
    <v-toolbar dark color="primary">
      <v-toolbar-title>Edit Town</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-toolbar-items>
        <v-btn dark text @click="UpdateTown()">Save</v-btn>
      </v-toolbar-items>
    </v-toolbar>
    <v-form ref="NewTown" class="pa-4">
      <v-row>
        <v-col col="12" md="3">
          <v-text-field v-model="newTown.Name" label="Name" outlined></v-text-field>
        </v-col>
        <v-col col="12" md="4">
          <v-text-field v-model="newTown.Size" label="Size" outlined></v-text-field>
        </v-col>
        <v-col col="12" md="4">
          <v-text-field v-model="newTown.Region" label="Region" outlined></v-text-field>
        </v-col>
        <v-col col="12" md="1">
          <v-checkbox v-model="newTown.Public" label="Public"></v-checkbox>
        </v-col>
      </v-row>
      <v-row>
        <v-col col="12">
          <v-textarea rows="2" v-model="newTown.Description" label="Description" outlined></v-textarea>
        </v-col>
      </v-row>
      <v-row>
        <v-col col="12">
          <v-textarea rows="4" v-model="newTown.Notes" label="Summary" outlined></v-textarea>
        </v-col>
      </v-row>
    </v-form>
  </v-card>
</template>

<script>
import db from "@/fb";
import firebase from "firebase/app";
import "firebase/auth";

export default {
  name: "Towns",
  data: () => ({
    newTown: {},
    dialog: false
  }),
  components: {},
  methods: {
    UpdateTown() {
      this.newTown.PlayerId = this.playerid;
      this.newTown.UpdateDate = firebase.firestore.FieldValue.serverTimestamp();
      db.collection("towns")
        .doc(this.$route.params.id)
        .update(this.newTown)
        .then(() => {
          this.$router.push({
            name: "Town",
            params: { id: this.$route.params.id }
          });
        });
    }
  },

  firestore() {
    this.$bind("newTown", db.collection("towns").doc(this.$route.params.id));
  },
  created() {
    firebase.auth().onAuthStateChanged(cred => {
      this.playerid = cred.uid;
    });
  }
};
</script>


